import { render, staticRenderFns } from "./ListsTournament.vue?vue&type=template&id=5b7d6c7a&scoped=true"
import script from "./ListsTournament.vue?vue&type=script&lang=js"
export * from "./ListsTournament.vue?vue&type=script&lang=js"
import style0 from "./ListsTournament.vue?vue&type=style&index=0&id=5b7d6c7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7d6c7a",
  null
  
)

export default component.exports